import { DefaultTheme } from "styled-components";

export const theme: DefaultTheme = {
  shadows: {
    box: "0px 2px 16px -4px rgba(95,95,146,.10)",
    modal: "0px 2px 10px -6px rgba(0,0,0,0.2)",
    navBar: "0px -3px 20px -6px rgba(0,0,0,.06)",
    button: "0px 2px 6px -4px rgba(0,0,0,.04)",
    floatBtn: "0 2px 10px -2px rgba(0,0,0,.2)",
    sideMenu: "0px 2px 10px -4px rgba(0,0,0,.12)",
    floatComment: "0px 2px 16px -4px rgba(0,0,0,.10)",
  },

  colors: {
    // Colors
    primary100: "#2F54EB",
    primary12: "#2F54EB1f",
    primary10: "#2F54EB19",
    primary8: "#2F54EB14",
    primary5: "#2F54EB0d",
    bright100: "#597EF7",
    bright100Hover: "#476DEA",
    accent100: "#FFC04C",
    accent100Hover: "#CF0F56",
    required100: "#E61260",
    required100Hover: "#E54C5F",
    errored100: "#EC6172",
    errored100Hover: "#FBB025",

    // Basic
    white100: "#ffffff",
    white80: "#ffffffcc",
    white70: "#ffffffb3",
    white60: "#ffffff99",
    white38: "#ffffff61",
    white12: "#ffffff1f",
    black100: "#000000",
    black90: "#000000e6",
    black80: "#000000cc",
    black70: "#000000b3",
    black60: "#00000099",
    black50: "#00000080",
    black38: "#00000061",
    black30: "#0000004C",
    black12: "#0000001f",
    black10: "#00000019",
    black8: "#00000014",
    black5: "#0000000d",
    black4: "#00000004",
    black2: "#00000005",
    gray100: "#E6E6E6",
    yellow100: "#FFD000",
    yellow20: "#FFD00033",
    yellow12: "#FFD0001f",
    green100: "#77DA63",
    green20: "#77DA6333",
    green12: "#77DA631f",
    red100: "#FF5253",
    red20: "#FF525333",
    red12: "#FF52531f",
    blue100: "#1677FF",
    blue20: "#1677FF33",
    blue12: "#1677FF1f",
    darkgray100: "#5F6368",
    darkgray20: "#5F636833",
    darkgray12: "#5F63681f",
    lightgray100: "#C9CBD6",

    // Text
    text1: "#B4B4BF",
    text2: "#797D8E",
    text3: "#555763",
    text4: "#03071B",
    text5: "#333644",
    text450: "#03071B80",

    // Background
    mainBg: "#F9F9FB",
    primaryBg: "#F6F7FA",
    primaryBg20: "#F7F8FB33",

    // Component
    border: "#F7F7F7",
    inputBg: "#F2F2F3",
    textLabel: "#878787",
    inputLabel: "#828282",
    inputBorder: "#DDDDDD",
    inputPlaceholder: "#B4B4BF",
  },
};
